import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class NativeSelect extends Component {
    initialized() {
        super.initialized();
        this.updateLabel();
    }
    bindEvents(add) {
        const method = bindMethod(add);
        if (this.refs.select)
            this.refs.select[method]('change', this.onChange);
        else
            this.el.querySelector('select')?.[method]('change', this.onChange);
    }
    onChange = (e) => {
        const select = e.currentTarget;
        this.emit('change', select.options[select.selectedIndex]);
        this.updateLabel();
        this.el.classList.add('filled');
    };
    updateLabel() {
        if (this.refs.select && this.refs.select.value && this.refs.nativeSelectLabel)
            this.refs.nativeSelectLabel.textContent = this.refs.select.value;
    }
    reset() {
        if (this.refs.select) {
            this.refs.select.value = '';
            this.refs.select.removeAttribute('required');
            this.refs.select.removeAttribute('data-required');
            this.refs.select.removeAttribute('data-validation');
        }
        this.updateLabel();
        this.el.classList.remove('filled');
    }
}
